import { render, staticRenderFns } from "./CommonPanel.vue?vue&type=template&id=00910a84&scoped=true&"
import script from "./CommonPanel.vue?vue&type=script&lang=js&"
export * from "./CommonPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00910a84",
  null
  
)

export default component.exports